import utils from '@/resources/utils.js';
import { useFeaturesStore } from '@/store/pinia/features';

function isOnOutdatedAppVersion(installedAppVersion, minimumSupportedAppVersion) {
  if (!installedAppVersion) {
    return true; // latest apps must be able to send current installed version, if not, assume outdated
  }
  if (!minimumSupportedAppVersion) {
    return false; // minimum supported version is not configured, system does not enforce any version
  }
  const installedVersion = installedAppVersion.split('.').map((v) => parseInt(v, 10));
  const minimumVersion = minimumSupportedAppVersion.split('.').map((v) => parseInt(v, 10));

  for (let i = 0; i < Math.max(installedVersion.length, minimumVersion.length); i++) {
    const installed = installedVersion[i] || 0;
    const minimum = minimumVersion[i] || 0;
    if (installed < minimum) {
      return true;
    } else if (installed > minimum) {
      return false;
    }
  }
  return false;
}

function checkAppVersionStatus() {
  const isMacOs = window.navigator.platform.match(/mac/gi);
  const { macOS, windowsOS } = window.__INITIAL_STATE__.config.minimumSupportedAppVersion;
  return new Promise((resolve) => {
    ipcApi
      .send({ name: 'getAppVersion' })
      .then((resp) => {
        const appVersion = resp?.version;
        const minSupportedVersion = isMacOs ? macOS : windowsOS;
        resolve({ isOnOutdatedAppVersion: isOnOutdatedAppVersion(appVersion, minSupportedVersion) });
      })
      .catch((err) => {
        console.error('Error checking app version:', err);
        resolve({ isOnOutdatedAppVersion: false });
      });
  });
}

export default () => async (to, from, next) => {
  if (!utils.isOpenedWithinElectronShell()) {
    return next(); // not in Electron shell, no need to check app version
  }

  if (to.name === 'unsupportedAppVersion') {
    return next(); // already on unsupported app version page, no need to check again
  }
  const featuresStore = useFeaturesStore();

  return checkAppVersionStatus().then(({ isOnOutdatedAppVersion }) => {
    if (isOnOutdatedAppVersion) {
      featuresStore.setUsersUsingOutdatedAppVersion(true);
      return next({ name: 'unsupportedAppVersion' });
    }
    next();
  });
};
